import { PayloadAction } from "@reduxjs/toolkit";
import { CustomerState } from "../customer.slice.ts";
import { IncomeMonthlyRequest } from "../../../../orchestrator-api-client";

export const submitIncomeReducer = (
  state: CustomerState,
  action: PayloadAction<IncomeMonthlyRequest>,
) => {
  state.job.income.netMonthlySalary = action.payload.netMonthlySalary;
  state.job.income.monthsSalary = action.payload.monthsSalary;
};
